export const createNewItemFromQuery = (employerName: string) => ({
  employerName,
  employerId: "",
});
